<script>
import PersonDetail from "./person_detail.vue";

export default {
  components: { PersonDetail },
  props: {
    currentEmpresa: { type: Object, required: true },
    listResponsibles: { type: Array, required: true },
    canView: { type: Boolean, default: false },
    canEdit: { type: Boolean, default: false },
    canDelete: { type: Boolean, default: false },
  },
  data() {
    return {
      titleBody: 'Listagem dos Pacientes',
      currentResponsible: undefined,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        { label: "ID", key: "id", sortable: true, tdClass: 'text-center', thClass: 'text-center' },
        { label: 'Nome', key: 'name', sortable: true, thClass: 'text-center' },
        { label: "Celular", key: "celular", sortable: true, thClass: 'text-center' },
        { label: "Ativo", key: "status", sortable: true, thClass: 'text-center' },
        { label: "Ações", key: "acoes", sortable: false, tdClass: 'text-center', thClass: 'text-center' }
      ],
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return (this.listResponsibles.length) ? this.listResponsibles.length : 0;
    },
    clonefoot() {
      return (this.listResponsibles.length || this.listResponsibles.length > 10) ? true : false;
    },
  },
  mounted() {
    this.$emit('newTitle', this.titleBody);
  },
  created(){
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    editar(currentResponsible) {
      this.$emit('edit', currentResponsible);
    },
    excluir(currentResponsible) {
      this.$emit('doDelete', currentResponsible);
    },
    setResponsible(currentResponsible) {
        this.currentResponsible = currentResponsible;
    },
  },
}
</script>

<template>
<div class="card-body">
  <div class="row mt-4">
    <!-- Start Limit -->
    <div class="col-sm-12 col-md-6">
      <div id="responsible-table_length" class="dataTables_length">
        <label class="d-inline-flex align-items-center">
          Exibir&nbsp;
          <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;registros
        </label>
      </div>
    </div>
    <!-- End Limit -->
    <!-- Start Search -->
    <div class="col-sm-12 col-md-6">
      <div id="responsible-table_filter" class="dataTables_filter text-md-right">
        <label class="d-inline-flex align-items-center">
          Pesquisar:
          <b-form-input
          v-model="filter"
          type="search"
          placeholder="Pesquisar..."
          class="form-control form-control-sm ml-2"
          ></b-form-input>
        </label>
      </div>
    </div>
    <!-- End search -->
  </div>
   <!-- Start Table -->
   <div class="row mt-4">
    <div class="table-responsive mb-0">
      <b-table
       id="responsible-table"
       :items="listResponsibles"
       :fields="fields"
       responsive="sm"
       :per-page="perPage"
       :current-page="currentPage"
       :sort-by.sync="sortBy"
       :sort-desc.sync="sortDesc"
       :filter="filter"
       :filter-included-fields="filterOn"
       @filtered="onFiltered"
       :hover=true
       :foot-clone=clonefoot
      >
        <template #cell(status)="row">
          {{ (row.item.status === 1) ? 'Sim' : 'Não' }}
        </template>
        <template #cell(acoes)="row">
          <!-- `data.value` is the value after formatted by the Formatter -->
          <b-dropdown v-if="canView || canEdit || canDelete" v-bind:id="'dropdown-'+ row.item.id" class="m-md-2">
            <template #button-content>
              <i data-v-6289eca4="" class="bx ri-menu-line"></i>
            </template>
            <b-dropdown-item
              v-if="canView"
              v-b-modal.modal-responsible
              @click="setResponsible(row.item)"
            >
              <i class="bx ri-file-search-line"></i> Visualizar
            </b-dropdown-item>
            <b-dropdown-item v-if="canEdit" @click="editar(row.item)"><i class="bx ri-edit-2-line"></i> Alterar</b-dropdown-item>
            <b-dropdown-item v-if="canDelete" @click="excluir(row.item)"><i class="bx ri-eraser-fill"></i> Excluir</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </div>
   </div>
   <!-- End Table -->
   <!-- Start Pagination -->
  <div class="row mt-4">
    <div class="col">
      <div class="dataTables_paginate paging_simple_numbers float-right">
        <ul class="pagination pagination-rounded mb-0">
          <!-- pagination -->
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
        </ul>
      </div>
    </div>
  </div>
  <!-- End Pagination -->

  <b-modal
    id="modal-responsible"
    title="Visualizar Responsável"
    title-class="font-18"
    ok-only
    size="xl"
  >
    <PersonDetail :current-responsible="currentResponsible" />
  </b-modal>
</div>
</template>